import { render, staticRenderFns } from "./CodePicker.vue?vue&type=template&id=31a7f4b2&scoped=true&"
import script from "./CodePicker.vue?vue&type=script&lang=js&"
export * from "./CodePicker.vue?vue&type=script&lang=js&"
import style0 from "./CodePicker.vue?vue&type=style&index=0&id=31a7f4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7f4b2",
  null
  
)

export default component.exports